import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin, Send, ShieldCheck } from 'lucide-react';
import { PageWrapper } from '../components/MotionWrappers';
export function Contact() {
  return <PageWrapper data-id="element-520">
      <section className="py-24 bg-white" data-id="element-521">
        <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-522">
          <div className="grid lg:grid-cols-2 gap-16" data-id="element-523">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.5,
            ease: [0.22, 1, 0.36, 1]
          }} data-id="element-524">
              <h1 className="text-4xl md:text-5xl font-black text-federal-blue mb-8" data-id="element-525">
                Contact Our <br data-id="element-526" />
                <span className="text-tech-slate" data-id="element-527">Federal Solutions Team</span>
              </h1>
              <p className="text-lg text-tech-slate mb-12 opacity-80 leading-relaxed" data-id="element-528">
                Ready to secure your agency's mission? Our team is available for
                rapid response consultations across the Mid-Atlantic and
                Southeast regions.
              </p>
              <div className="space-y-8" data-id="element-529">
                <div className="flex items-start gap-4" data-id="element-530">
                  <div className="w-12 h-12 bg-federal-blue/5 flex items-center justify-center rounded-sm" data-id="element-531">
                    <Mail className="w-6 h-6 text-federal-blue" data-id="element-532" />
                  </div>
                  <div data-id="element-533">
                    <h4 className="font-bold text-federal-blue uppercase text-xs tracking-widest mb-1" data-id="element-534">
                      Email
                    </h4>
                    <p className="text-tech-slate font-medium" data-id="element-535">
                      gov@codesandcogs.com
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-id="element-536">
                  <div className="w-12 h-12 bg-federal-blue/5 flex items-center justify-center rounded-sm" data-id="element-537">
                    <Phone className="w-6 h-6 text-federal-blue" data-id="element-538" />
                  </div>
                  <div data-id="element-539">
                    <h4 className="font-bold text-federal-blue uppercase text-xs tracking-widest mb-1" data-id="element-540">
                      Phone
                    </h4>
                    <p className="text-tech-slate font-medium" data-id="element-541">
                      +1 (800) COGS-GOV
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-id="element-542">
                  <div className="w-12 h-12 bg-federal-blue/5 flex items-center justify-center rounded-sm" data-id="element-543">
                    <MapPin className="w-6 h-6 text-federal-blue" data-id="element-544" />
                  </div>
                  <div data-id="element-545">
                    <h4 className="font-bold text-federal-blue uppercase text-xs tracking-widest mb-1" data-id="element-546">
                      Headquarters
                    </h4>
                    <p className="text-tech-slate font-medium" data-id="element-547">
                      Charlotte, NC | Baltimore, MD
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.5,
            ease: [0.22, 1, 0.36, 1],
            delay: 0.1
          }} className="bg-slate-50 p-8 md:p-12 border border-slate-200 shadow-sm" data-id="element-548">
              <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-549">
                <div className="grid md:grid-cols-2 gap-6" data-id="element-550">
                  <div className="space-y-2" data-id="element-551">
                    <label className="text-[10px] font-black uppercase tracking-widest text-tech-slate" data-id="element-552">
                      Full Name
                    </label>
                    <input type="text" className="w-full px-4 py-3 bg-white border border-slate-200 focus:ring-2 focus:ring-federal-blue outline-none transition-all" placeholder="John Doe" data-id="element-553" />
                  </div>
                  <div className="space-y-2" data-id="element-554">
                    <label className="text-[10px] font-black uppercase tracking-widest text-tech-slate" data-id="element-555">
                      Agency / Organization
                    </label>
                    <input type="text" className="w-full px-4 py-3 bg-white border border-slate-200 focus:ring-2 focus:ring-federal-blue outline-none transition-all" placeholder="e.g. GSA" data-id="element-556" />
                  </div>
                </div>
                <div className="space-y-2" data-id="element-557">
                  <label className="text-[10px] font-black uppercase tracking-widest text-tech-slate" data-id="element-558">
                    Work Email (.gov / .mil preferred)
                  </label>
                  <input type="email" className="w-full px-4 py-3 bg-white border border-slate-200 focus:ring-2 focus:ring-federal-blue outline-none transition-all" placeholder="j.doe@agency.gov" data-id="element-559" />
                </div>
                <div className="space-y-2" data-id="element-560">
                  <label className="text-[10px] font-black uppercase tracking-widest text-tech-slate" data-id="element-561">
                    Message
                  </label>
                  <textarea rows={4} className="w-full px-4 py-3 bg-white border border-slate-200 focus:ring-2 focus:ring-federal-blue outline-none transition-all" placeholder="How can we support your mission?" data-id="element-562"></textarea>
                </div>
                <motion.button whileHover={{
                scale: 1.02
              }} whileTap={{
                scale: 0.98
              }} className="w-full bg-federal-blue hover:bg-federal-blue/90 text-white py-4 font-bold flex items-center justify-center gap-2 transition-all shadow-lg" data-id="element-563">
                  <Send className="w-4 h-4" data-id="element-564" />
                  Submit Secure Inquiry
                </motion.button>
                <p className="text-[10px] text-center text-tech-slate opacity-60 flex items-center justify-center gap-1.5 uppercase font-bold tracking-tighter" data-id="element-565">
                  <ShieldCheck className="w-3 h-3" data-id="element-566" />
                  Encrypted & NIST 800-171 Compliant Submission
                </p>
              </form>
            </motion.div>
          </div>
        </div>
      </section>
    </PageWrapper>;
}